import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApplicationService } from '../Services/application.service';
import { IApplication } from '../models/application.model';
import { HeaderService } from '../Services/header.service';

@Component({
  selector: 'ad-grid',
  templateUrl: './application.component.html',
  styleUrls: ['../app.component.scss']
})
export class ApplicationComponent implements OnInit {

  searchSub: Subscription;
  constructor(private applicationService: ApplicationService, private headerService: HeaderService) { }

  errorMessage = '';
  apps: IApplication[];
  filteredApps: IApplication[];

  performFilter(term: string) {
    if (term > '') {
      const filterTerm = term.toLocaleLowerCase();
      this.filteredApps = this.apps.filter((app: IApplication) =>
        app.appName.toLocaleLowerCase().indexOf(filterTerm) !== -1);
    } else {
      this.filteredApps = this.apps;
    }
  }

  ngOnInit(): void {
    this.searchSub = this.headerService.filterTerm$.subscribe(
      term => {
        this.performFilter(term);
      });

    this.headerService.searchTerm = '';
    this.headerService.setBreadcrumbs();
    this.applicationService.getApplications().subscribe({
      next: response => {
        this.apps = response;

        this.filteredApps = this.apps;
      },
      error: err => this.errorMessage = err
    });
  }
}
